/**
 * Get the absolute Y (top) position of an element in the document.
 * i.e. not it's relative position to the current viewport,
 * but it's fixed position relative to the top of the document
 *
 * @param {String} querySelector The CSS selector of the element you want to find the position of
 *
 * @returns Integer
 *
 * @source https://stackoverflow.com/questions/442404/retrieve-the-position-x-y-of-an-html-element
 */
export const getElementAbsoluteYPosition = (querySelector) => {
    const pageElement = document.querySelector(querySelector);
    if (!pageElement) {
        return 0;
    }
    const pageElementRect = pageElement.getBoundingClientRect();
    const currentScrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
    return pageElementRect.top + currentScrollTop;
};

/**
 * Generate a (mostly) unique ID in an RFC4122 version 4 compliant format
 *
 * @returns String
 *
 * @source https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
 */
export const uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
};

/**
 * Email Validation
 *
 * @returns Boolean
 *
 */
export const emailValidation = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
